import ApplicationController from "application_controller.js";
import * as Turbo from "@hotwired/turbo";

export default class extends ApplicationController {

  debug = false;

  static targets = ["button", "skeleton"];

  static values = {
    url: String,
    auto: { type: Boolean, default: true },
  };

  connect() {
    this.log_function("connect");

    if (this.autoValue) {
      // Defer observation to prevent immediate triggering after turbo_stream replacement
      requestAnimationFrame(() => {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.loadMore();
              }
            });
          },
          { rootMargin: "200px" },
        );
        this.observer.observe(this.element);
      });
    }
  }

  async loadMore(event) {
    this.log_function("loadMore");

    if (this.loading) return;

    this.loading = true;
    this.observer?.disconnect();

    if (this.hasButtonTarget) {
      this.showSkeletonLoading();
    }

    try {
      const response = await fetch(this.urlValue, {
        headers: {
          Accept: "text/vnd.turbo-stream.html",
        },
      });

      if (response.ok) {
        const html = await response.text();
        Turbo.renderStreamMessage(html);
        this.removeSkeletonLoading();
      } else {
        this.handleOffline();
      }
    } catch (error) {
      this.log_error_function("loadMore", error);
      this.handleOffline();
    }
  }

  handleOffline() {
    this.log_function("handleOffline");

    this.loading = false;

    //* Listen for reconnection
    this.onlineHandler = this.handleReconnect.bind(this);
    window.addEventListener("online", this.onlineHandler, { once: true });
  }

  handleReconnect() {
    this.log_function("handleReconnect");

    this.removeSkeletonLoading();
    this.loadMore();
  }

  disconnect() {
    this.log_function("disconnect");

    this.observer?.disconnect();
    if (this.onlineHandler) {
      window.removeEventListener("online", this.onlineHandler);
    }
  }

  showSkeletonLoading() {
    if (!this.hasSkeletonTarget) return;

    const eventsList = document.getElementById("events-list");

    if (eventsList) {
      const clone = this.skeletonTarget.content.cloneNode(true);
      eventsList.appendChild(clone);
    }

    //* Hide the button
    if (this.hasButtonTarget) {
      this.buttonTarget.hidden = true;
    }
  }

  removeSkeletonLoading() {
    const skeletons = document.querySelectorAll("[data-event-preview-skeleton]");
    skeletons.forEach((el) => el.remove());
  }
}
